import Tippy from "@tippyjs/react";
import { useSelector } from "react-redux";
import { isMobile } from "react-device-detect";

const Tooltip = ({ children, content, ...rest }) => {
  const theme = useSelector((state) => state.theme.mode);

  return (
    <Tippy
      hideOnClick
      zIndex={10000001}
      content={content}
      animation="scale-extreme"
      theme={theme}
      {...rest}
      disabled={rest.disabled || isMobile}
    >
      {children}
    </Tippy>
  );
};

export default Tooltip;
